<template>
    <div id="app" v-bind:class="{dpn:!pageInit}">

    </div>
</template>


<script>
    import common from '../assets/js/common'

    export default {
        name: 'HelloWorld',
        props: {
            msg: String
        },
        components:
            {
            },
        data: function(){
            return {
                pageInit:false
            }
        },
        methods:{

        },
        created:function()
        {
            let token = this.$route.query.token
            this.$store.commit('setAccessToken',token)
            // console.log(this.$store.state.accessToken)
            // this.$router.push('/auth')
        },
        mounted:function(){
        }
    }
</script>


<style>
    html,body{background: #f8f8f8 !important;}
    html{min-height: 100%}

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }
    #nav {
        padding: 30px;
    }

    #nav a {
        font-weight: bold;
        color: #2c3e50;
    }

    #nav a.router-link-exact-active {
        color: #42b983;
    }

    .disableText{color:#999999 !important;}

    .in-bl{display: inline-block;}

    p{font-size: 0.375rem;}
</style>